var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338.5 338.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5da79a;}.cls-2,.cls-3{fill:#97fc68;}.cls-2{opacity:0.4;}.cls-4{fill:#9ce8e6;opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 168.97,
    cy: 168.97,
    r: 168.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.2,333.7A169,169,0,0,0,172.63.55c.48,6.36,3.19,13.44,8.78,21.06,20.8,28.35,54.5,47.12,75.89,74.91C302.18,154.8,313.11,233.19,239.21,273c-29.94,16.14-70.49,20.4-101.44,7.07-35.65-15.36-39.09-51.8-41.39-86.3C94.09,159.47,108,100.83,82.79,71.89c-6.7-7.68-28.79-22.6-45.92-7A168.94,168.94,0,0,0,209.2,333.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.11,145.41l-4.76-.4c-19.51-4.19-29.73,41.73-1.16,33.11,9.32-2.82,18.4-7.29,20.49-18.34C50.82,148.5,43.2,146.37,34.11,145.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.06,106.06C57.16,89.89,25.6,112.72,31,122.24,31.93,133.07,75,126.45,65.06,106.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.13,157.72c-7.9-16.17-39.46,6.66-34.05,16.18C259,184.73,302.09,178.11,292.13,157.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.23,134.44,53.62,136c-.86,11.52,17.51,19.92,26.09,11.44C91.87,135.46,63.24,134.23,60.23,134.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.74,312.77l-6.62,1.59c-.86,11.52,17.52,19.93,26.09,11.45C203.37,313.79,174.74,312.56,171.74,312.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.56,102.13c-13.18-8.26-26.92,8.92-33.94,17.36l4.2,1.32c-.65.32-1.39.25-2.07.61C75.29,139,125.81,115.47,104.56,102.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.18,87.82l-1.29,1.09c2.63,9.84,20.23,4.49,18.92-5.35C92.11,70.77,72.08,77.19,76.18,87.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.75,154.86,299.46,156c2.63,9.84,20.23,4.49,18.92-5.35C316.68,137.81,296.65,144.23,300.75,154.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.88,66.8c-9-2.37-45.42,3.76-38.89,18l4.38,2c5.85,5.82,22.52,3.83,29.53.64C147.12,83.7,156.74,70.19,143.88,66.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.48,82.94c-6.08-7.5-29.9-2.75-25.45,9.88l.74-.18C158.32,95.1,188.82,96.94,177.48,82.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.83,275.08c2.79-9.24-14.53-26.27-22.48-15.49l.56.51C50,266.07,65.63,292.33,70.83,275.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.19,202.28c-6.07-7.5-29.9-2.75-25.44,9.88l.73-.18C205,214.44,235.54,216.28,224.19,202.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.33,44.72c-4.76-5.3-14.2-1.73-19.07-2.4l-16.92,7.2C161.22,51,159.2,59.9,167.05,64.31c7.26,4.08,21,1.23,28.11-2.08C201,59.54,212.4,51.5,206.33,44.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.36,69.85c-5.85-2.41-9.89-1.7-11.94-7.61-2.39-6.89,1.06-9.72-9.61-8.37-8.11,1-26.54,7.69-28.49,16.41l0,.59,2.15,5.7c5.59,14,30.23,18.68,43.32,15.19C261.75,88.57,268.12,75.51,254.36,69.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254,35.52l-4.41,1.07c-9,5.85,8.86,20.07,16.76,14.47C274.67,45.18,259.72,36.28,254,35.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.7,94.85l-10.44-1.37c-19.48,3.26-14.22,36.3,5.46,29,5.81-2.15,12-11.67,11-18.22C297.05,100.35,291.46,95.65,291.7,94.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.41,82.63l-3.65-2.23C290.19,82.31,299.08,97,304.64,97,314.83,97.06,307,83.28,300.41,82.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,175.5l-3.65-2.23c-6.57,1.91,2.32,16.58,7.88,16.61C329.5,189.93,321.65,176.15,315.07,175.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.82,191.42l-3.65-2.23c-6.57,1.91,2.31,16.57,7.88,16.6C302.24,205.85,294.4,192.07,287.82,191.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.91,276.73c-12.29-1.87-33.68-11.57-33.8,7.48,1.11-.36,0-.75.28-1.52l3.8,6.08c-18,12.07,14.1,23,22.17,26.52,8.71,3.81,19.76,7.59,29.1,3.13,9.89-4.72,20.63-18.47,19.45-29.63C149.66,267.72,124.49,278.79,110.91,276.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.7,265.46c-6,.2-16.12-4.3-18.49,4.65l2.69,7.9c2.77,9.46-2.68,20.34,11,20.87,11.18.43,29.49-14.07,29.66-25.49C198.8,259.9,181.89,265.2,173.7,265.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.08,245.69c-11.33-15.63-46.75-.93-32.7,9.45l2,5c6.54,3.35,14.51,6.37,22,4C148.55,261.85,154.85,252.25,150.08,245.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.11,230.61c-6.61-12.82-32.19-4.35-30,8l2.33,6.43C163.88,254.23,203,249.83,193.11,230.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.76,246.62a2.08,2.08,0,0,0-.13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.76,246.62a5.32,5.32,0,0,1,1.12-1.25l-3.16,6.21c-1.51,10.87,26.81,8.11,24.25-5.9C221.8,233.83,205.51,237.84,201.76,246.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261,193.22l-6.26,3.07c-6.24.72-24.62,11.63-24.83,19.27-.29,10.64,14.13,6.23,19.73,4.51,7.39-2.27,19.74-8.87,22.31-17C275.42,192.1,263.91,195.6,261,193.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.63,217.74c-9.86,2.11.65,11.48,9.09,6.16,10.81-6.81.72-12.39-7.6-9.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.82,54.93C163,71.46,145.4,96.46,115.65,107.07c-18.9,6.74-37.49,11.3-55.3,21.08-23.81,13.06-76.78,46.48-46.91,77.94,32,33.74,63.63,9,86.5-20.58,22.44-29,63.27-71.3,104-68.48,24.69,1.71,47.19,13.85,72.3,6.44,8.4-2.47,18.16-7,23.57-14.24,4.92-6.59,3.27-10.75,1.81-18.3C298.69,75.7,268.22,4.1,188.82,54.93Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.647f6e26068152c8faf653368018547c.svg";
export { ForwardRef as ReactComponent };